// extracted by mini-css-extract-plugin
export var backdropBlur = "_ju-0";
export var contentCard = "_ju-5";
export var frame = "_ju-2";
export var image = "_ju-4";
export var imagePane = "_ju-3";
export var modal = "_ju-1";